function getHost() {
    // 线下环境
    if (!/\.umucdn\./i.test(window.location.href)) {
        return '';
    }
    var location = window.location;
    var host = location.protocol + '//' + location.hostname;
    return host;
}

/**
 * 是否开发环境
 * @returns boolean
 */
function isDevHost() {
    return /\.umucdn\./i.test(window.location.href);
}

/**
 * 获取Protocol，默认是https, 线下保洁和高瓴是http和https都可以
 * http://umu-hh-test.umucdn.cn
   http://umu-pg-test.umucdn.cn
 * @returns boolean
 */
function getProtocol(url) {
    // if (isDevHost()) {
    //     return /umu-(hh|pg)-test/i.test(url) ? 'http:' : 'https:'
    // }
    return 'https:';
}

module.exports = {
    getHost: getHost,
    isDevHost: isDevHost,
    getProtocol: getProtocol,
};
